export default __webpack_public_path__ + "static/media/RealEstate.8dda8925.png";